import { Pipe, PipeTransform } from '@angular/core';
import { PriceListCode } from 'src/app/core/models/price-list-code';



@Pipe({
  name: 'pricelistCodeFilter'
})
export class PricelistCodeFilterPipe implements PipeTransform {

  transform(list: PriceListCode[], text?: string): any {

    if (!text) {
      return list;
    }

    return list.filter(x => {
      if (x.Name && x.Name.toUpperCase().indexOf(text.toUpperCase()) > -1) {
        return true;
      }
      if (x.Code && x.Code.toUpperCase().indexOf(text.toUpperCase()) > -1) {
        return true;
      }
      if (x.Description && x.Description.toUpperCase().indexOf(text.toUpperCase()) > -1) {
        return true;
      }
      if (x.Price && x.Price.toString().toUpperCase().indexOf(text.toUpperCase()) > -1) {
        return true;
      }
      return false;
    });
  }

}
